<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Ürün Hareketi {{data.productMovement ? 'Güncelle' : 'Oluştur'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="form">
      <label>Depo Seç</label>
      <div class="form-group">
        <ng-select [items]="warehouse" bindLabel="warehouseName" bindValue="id"
        formControlName="warehouseId"></ng-select>
      </div>
      <label>Adet</label>
      <div class="form-group">
        <input type="number" id="seriNo" formControlName="count"
          placeholder="Kaç adet giriniz." class="form-control" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()" rippleEffect>
      İptal
    </button>
    <button type="button" class="btn btn-success" rippleEffect (click)="createProductSerial()">
      {{data.productMovement ? 'Güncelle' : 'Ekle'}}
    </button>
  </div>
  